var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVifly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 26,
    viewBox: "0 0 51 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.994902 8.26835C-0.106231 6.3532 0.553661 3.90802 2.46881 2.80689C4.38396 1.70576 6.82914 2.36565 7.93028 4.2808L16.6185 19.3919C17.7197 21.3071 17.0598 23.7523 15.1446 24.8534C13.2295 25.9545 10.7843 25.2946 9.68317 23.3795L0.994902 8.26835Z",
    fill: "#CBD5E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.913 11.2348C14.8555 9.23686 17.2393 8.38127 19.2372 9.32382C21.2352 10.2664 22.0908 12.6501 21.1483 14.6481L17.4799 22.424C16.5374 24.422 14.1536 25.2776 12.1557 24.335C10.1577 23.3925 9.3021 21.0087 10.2446 19.0108L13.913 11.2348Z",
    fill: "#CBD5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.538 4.61719C25.538 6.82633 23.7471 8.61719 21.538 8.61719C19.3289 8.61719 17.538 6.82633 17.538 4.61719C17.538 2.40805 19.3289 0.617188 21.538 0.617188C23.7471 0.617188 25.538 2.40805 25.538 4.61719Z",
    fill: "#395BA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7781 11.4667C27.3834 11.4667 27.0528 11.3441 26.7861 11.0987C26.5301 10.8427 26.4021 10.5281 26.4021 10.1547C26.4021 9.78138 26.5301 9.47205 26.7861 9.22672C27.0528 8.97072 27.3834 8.84272 27.7781 8.84272C28.1728 8.84272 28.4981 8.97072 28.7541 9.22672C29.0208 9.47205 29.1541 9.78138 29.1541 10.1547C29.1541 10.5281 29.0208 10.8427 28.7541 11.0987C28.4981 11.3441 28.1728 11.4667 27.7781 11.4667ZM28.8821 12.5227V21.3867H26.6421V12.5227H28.8821ZM35.1592 14.3627H33.6072V21.3867H31.3352V14.3627H30.3272V12.5227H31.3352V12.0747C31.3352 10.9867 31.6445 10.1867 32.2632 9.67472C32.8819 9.16272 33.8152 8.92272 35.0632 8.95472V10.8427C34.5192 10.8321 34.1405 10.9227 33.9272 11.1147C33.7139 11.3067 33.6072 11.6534 33.6072 12.1547V12.5227H35.1592V14.3627ZM38.8508 9.54672V21.3867H36.6108V9.54672H38.8508ZM49.544 12.5227L44.056 25.5787H41.672L43.592 21.1627L40.04 12.5227H42.552L44.84 18.7147L47.16 12.5227H49.544Z",
    fill: "#395BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVifly);
export default __webpack_public_path__ + "static/media/vifly.49cf2d39eff97359c865f27dc04d8db5.svg";
export { ForwardRef as ReactComponent };